import { Anchor, Stack, Text, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { normalizeLanguage } from "../i18n";
import { RestApi } from "../shared/RestApi";
import { NavBarContainer } from "./NavBarContainer";

const FAKE_EMAILS = [
  {
    action: "distributorSignUp",
    labelKey: "distributorSignUp",
  },
  {
    action: "activationLink",
    labelKey: "activationLink",
  },
  {
    action: "sendEmailLicense",
    labelKey: "sendEmailLicense",
  },
  {
    action: "sendCongratulationEmail",
    labelKey: "congratulationEmail",
  },
  {
    action: "sendBoughtLicensesMail",
    labelKey: "boughtLicensesMail",
  },
] as const;

export function FakeEmailPage() {
  const { t, i18n } = useTranslation();
  const language = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);

  const { data, isPending, isError } = useQuery({
    queryKey: ["fakeEmails", language],
    queryFn: async () =>
      Promise.all(
        FAKE_EMAILS.map(async (email) => ({
          ...email,
          message: await RestApi.getFakeEmail(email.action, language),
        })),
      ),
  });

  return (
    <NavBarContainer title={t("fakeEmail.title")}>
      <Stack gap="xl">
        <Text size="sm" c="dimmed">
          {t("fakeEmail.description")}
        </Text>
        {isPending && <Text>{t("fakeEmail.loading")}</Text>}
        {isError && <Text c="red">{t("fakeEmail.loadError")}</Text>}
        {data?.map((email) => (
          <Stack key={email.action} gap="xs">
            <Title order={4}>{t(`fakeEmail.${email.labelKey}`)}</Title>
            <Text>
              <Text span fw={600}>
                {t("fakeEmail.subject")}:{" "}
              </Text>
              {email.message.subject}
            </Text>
            <Text fw={600}>{t("fakeEmail.body")}:</Text>
            <iframe
              title={t(`fakeEmail.${email.labelKey}`)}
              srcDoc={email.message.body}
              style={{
                width: "100%",
                minHeight: 320,
                border: "1px solid var(--mantine-color-gray-4)",
                borderRadius: 4,
                background: "white",
              }}
            />
          </Stack>
        ))}
        <Anchor component={Link} to="/admin">
          {t("fakeEmail.backAdmin")}
        </Anchor>
      </Stack>
    </NavBarContainer>
  );
}
